import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SweetAlertService from "../../../../services/SweetAlertService";
import WorkHourService from "../../Shared/Services/WorkHourService";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import { Popup, PopupProps } from "@progress/kendo-react-popup";
import moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { errorMessagesForWorkHourDetails, getRequiredErrorMessage } from "../../Shared/Constants/AdminModuleConstants";

export const AddWorkHourDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { register, getValues, control, handleSubmit, reset, formState: { errors } } = useForm();

    const [workhourTypes, setWorkhourTypes] = useState([]);

    useEffect(() => {
        getWorkhourTypes();
    }, []);

    const getWorkhourTypes = () => {
        WorkHourService.getWorkhourTypes().then((response) => {
            if (response.data) {
                setWorkhourTypes(response.data);
            }
        })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while getting work hour types");
            });
    }

    const CustomPopup = (props: PopupProps) => {
        return (
            <Popup
                {...props}
                anchorAlign={{
                    horizontal: 'left',
                    vertical: 'top',
                }}
                popupAlign={{
                    horizontal: 'left',
                    vertical: 'top',
                }}
            />
        );
    };

    const onformSubmit = (data: any) => {
        data.workHourId = Number(id);
        data.startTime = moment(data.startTime).format('HH:mm');
        data.endTime = moment(data.endTime).format('HH:mm');
        data.sessionLength = moment(data.sessionLength).format('HH:mm');
        data.workHourTypeId = data.WorkHourTypeId;
        WorkHourService.addWorkHourDetails(data).then((response) => {
            if (response.data > 0) {
                navigate(`/workhourDetails/${id}`);
            } else {
                console.log("Error : Something went wrong while adding session rate" + response.data);
            }
            // Reset form
            reset();
        }).catch(error => {
            if (error) {
                SweetAlertService.error("Error", error.response.data);
            }
        });
    }

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h4>Create session rate</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit(onformSubmit)}>
                        <div className="form-group row">
                            <label className="col-lg-3 control-label">
                                Work Hour Type
                            </label>
                            <div className="col-lg-9">
                                <select className="form-select"
                                    {...register("WorkHourTypeId", {
                                        required: getRequiredErrorMessage("WorkHourType"),
                                    })}>
                                    <option value="">please select</option>
                                    if (workhourTypes.length)
                                    {
                                        (workhourTypes).map((e: any) => (
                                            <option value={e.id} key={e.id}> {e.name}</option>
                                        ))
                                    }
                                </select>
                                {errors.WorkHourTypeId && (
                                    <span className="help-block m-b-none text-danger field-validation-valid">
                                        {errors.WorkHourTypeId.message?.toString()}
                                    </span>
                                )}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-lg-3 control-label justify-content-center">
                                Start Time
                            </label>
                            <div className="col-lg-9">
                                <Controller
                                    name="startTime"
                                    control={control}
                                    rules={{ required: getRequiredErrorMessage("Start time") }}
                                    render={({ field }) => (
                                        <TimePicker
                                            id="startTime"
                                            {...field}
                                            format="HH:mm"
                                            popup={CustomPopup}
                                            onChange={(event: any) => field.onChange(event.value)}
                                            onBlur={field.onBlur}
                                        />
                                    )}
                                />
                                {errors.startTime &&
                                    (<span className="help-block m-b-none text-danger field-validation-valid">
                                        {errors.startTime.message?.toString()}
                                    </span>
                                    )}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-lg-3 control-label justify-content-center">
                                End Time
                            </label>
                            <div className="col-lg-9">
                                <Controller
                                    name="endTime"
                                    control={control}
                                    rules={{ required: getRequiredErrorMessage("End time") }}
                                    render={({ field }) => (
                                        <TimePicker
                                            id="endTime"
                                            {...field}
                                            format="HH:mm"
                                            onChange={(event: any) => field.onChange(event.value)}
                                            onBlur={field.onBlur}
                                        />
                                    )}
                                />
                                {errors.endTime && (
                                    <span className="help-block m-b-none text-danger field-validation-valid">
                                        {errors.endTime.message?.toString()}
                                    </span>
                                )}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-lg-3 control-label justify-content-center">
                                Session Length
                            </label>
                            <div className="col-lg-9">
                                <Controller
                                    name="sessionLength"
                                    control={control}
                                    rules={{ required: getRequiredErrorMessage("Session length") }}
                                    render={({ field }) => (
                                        <TimePicker
                                            id="sessionLength"
                                            {...field}
                                            format="HH:mm"
                                            onChange={(event: any) => field.onChange(event.value)}
                                            onBlur={field.onBlur}
                                        />
                                    )}
                                />
                                {errors.sessionLength && (
                                    <span className="help-block m-b-none text-danger field-validation-valid">
                                        {errors.sessionLength.message?.toString()}
                                    </span>
                                )}
                            </div>
                        </div>
                        <br />
                        <div className="form-group row">
                            <div className=" col-sm-offset-3 px-2">
                                <a className="btn btn-secondary"
                                    onClick={() => navigate(`/workhourDetails/${id}`)}>
                                    Cancel
                                </a>
                                <button className="btn btn-primary ms-1"
                                    type="submit">
                                    Create
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}